import { createFileRoute } from "@tanstack/react-router";
import { requireGroup } from "./-guards";

// Layout route for the applicant route group (/applicant/*). Guard-only (default Outlet).
export const Route = createFileRoute("/applicant")({
  beforeLoad: ({ context, location }) =>
    requireGroup(context.queryClient, "applicant", location.pathname),
});
